<template>
  <div class="menu-asside-content">
    <div v-click-outside="onClickOutside" class="menu-asside">
      <div class="menu" v-for="i in items" :key="i.id">
        <router-link
          style="text-decoration: none;"
          :to="i.link"
          exact
          class="menu--item-link"
        >
          <span class="menu-asside--item">
            {{ i.text }}
          </span>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import vClickOutside from "v-click-outside";

export default {
  name: "AssideBarComponent",
  data: () => ({
    items: [
      { id: 0, text: "Home", link: "/" },
      { id: 1, text: "Mustwatch", link: "/mustwatch" },
      { id: 2, text: "Upcoming", link: "/newupdates" },
      { id: 3, text: "Kids", link: "/kids" },
      { id: 4, text: "New | Reviews", link: "/articles" },
      { id: 5, text: "Watchlist", link: "/watchlist" }
    ],
    directives: {
      clickOutside: vClickOutside.directive
    }
  }),
  computed: mapState(["menuLeftAsside"]),
  methods: {
    onClickOutside(event) {
      if (
        event.target.className == "menu-asside-content" ||
        event.target.className == "menu--item" ||
        event.target.className == "menu--item" ||
        event.target.className == "topbar" ||
        event.target.className == "search--input" ||
        event.target.className == "container"
      ) {
        this.$store.commit("DISABLED_MENU");
      }
    }
  }
};
</script>

<style scoped>
.menu-asside-content {
  background-color: rgba(44, 56, 72, 0.8);
  height: 200vh;
  width: 200vw;
  position: absolute;
  left: 0;
  top: 60px;
}
.menu-asside {
  background-color: #2c3848;
  width: 250px;
  position: absolute;
  left: 0;
}

.menu-asside > div {
  background-color: #1c2531;
  margin: 10px 0;
  padding: 10px 0;
  cursor: pointer;
}

.menu-asside--item {
  padding: 0px 10px;
  color: white;
}

@media (min-width: 1264px) {
}
</style>
